module.exports = __webpack_public_path__ + "img/secured-payment.c3fbe892.svg";